export const inputIsInvalid = (bid: number = 0, increment: number): boolean => {
  return bid < 0 || bid % increment !== 0;
};
